import axios from 'axios';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const SC_NOTE_SUBJECT = 'Success Coaching Encounter';

const replaceAll = (text, field, value) => (text || '').split(field).join(value || '');

// Fill the Success Coaching merge fields with the questions pop-up result
export const fillSuccessCoachingContent = (content, { topic, winWall, summary }) => {
  let out = replaceAll(content, '{{success_coaching_week_topic}}', topic);
  out = replaceAll(out, '{{win_wall}}', winWall);
  return replaceAll(out, '{{personalized_encounter_summary}}', summary);
};

export const unsuccessfulAttemptSummary = (weekInfo, firstName) => {
  const who = firstName || 'the participant';
  const topic = weekInfo?.topic ? ` (${weekInfo.topic})` : '';
  return `Due to an unsuccessful call attempt, the Week ${weekInfo?.week_number} Success Coaching topic information${topic} was sent to ${who} by email to ensure continued Success Coaching efforts were communicated.`;
};

// Unsuccessful call attempt: topic + fixed summary, and the Win-Wall line (with its label) removed
export const buildUnsuccessfulAttemptContent = (content, weekInfo, firstName) => {
  const lines = (content || '').split('\n');
  const kept = [];
  lines.forEach((line) => {
    if (line.includes('{{win_wall}}')) {
      const prev = kept[kept.length - 1];
      if (prev !== undefined && /win[\s-]?wall/i.test(prev) && prev.replace(/<[^>]*>/g, '').trim().endsWith(':')) kept.pop();
      return;
    }
    kept.push(line);
  });
  return fillSuccessCoachingContent(kept.join('\n'), {
    topic: weekInfo?.topic,
    winWall: '',
    summary: unsuccessfulAttemptSummary(weekInfo, firstName)
  });
};

export const fetchSuccessCoachingWeek = async (caseId) => {
  if (!caseId) return null;
  try {
    const { data } = await axios.get(`${API}/cases/${caseId}/success-coaching/current-week`);
    return data;
  } catch (e) {
    return null;
  }
};

export const sendSuccessCoachingMessages = async (caseId, weekNumber, noteId, winWall, unsuccessful = false) => {
  try {
    const { data } = await axios.post(`${API}/cases/${caseId}/success-coaching/send-messages`, {
      week_number: weekNumber, win_wall: winWall || '', note_id: noteId, unsuccessful
    });
    (data.results || []).forEach((r) => {
      const label = r.channel === 'email' ? 'Email' : 'Text';
      if (r.status === 'sent') toast.success(`Success Coaching ${label} sent to participant`);
      else toast.warning(`Success Coaching ${label} not sent: ${r.reason || r.status}`);
    });
  } catch (error) {
    toast.error(error.response?.data?.detail || 'Failed to send Success Coaching messages');
  }
};
